module.exports = __webpack_public_path__ + "img/home-delivery.4904ba71.webp";